import { MessageBox } from "element-ui";

const alert: any = {
  //删除操作弹出
  deleteAlert() {
    return MessageBox.confirm("确定要执行删除操作?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning" 
    });
  },
   //投放广告弹窗确定
   advertAlert() {
    return MessageBox.confirm("确定要投放广告?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
   //下线广告投放 
   offlineAlert() {
    return MessageBox.confirm("确定要下线广告投放?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
  alert(msg: string) {
    return MessageBox.confirm(msg, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  }
};
export default alert;
